module.exports = __webpack_public_path__ + "img/DSC_0002.b4717d31.jpg";